import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/react';
import 'maplibre-gl/dist/maplibre-gl.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './app';

const appEnv = process.env.REACT_APP_ENV;
const sentryEnvironment = appEnv ? appEnv : 'development';

Sentry.init({
  dsn: 'https://4856d5efd7004b8789bddd0ec8cbfeb1@o310561.ingest.sentry.io/4504798235066368',
  environment: sentryEnvironment,
  integrations: [
    browserTracingIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
  ],
  tracesSampleRate: 0.001,
  beforeSend(event, hint) {
    const error = hint.originalException as Error | undefined;
    if (event.tags?.['browser.name'] === 'FacebookBot') return null;
    if (error?.message?.match(/Failed to initialize WebGL./i)) return null;
    if (error?.message?.match(/Content Security Policy/i)) return event;
    if (error?.message?.match(/amplitude/i) || event.message?.match(/amplitude/i)) return null;

    return event;
  },
  initialScope: {
    tags: {
      package: 'companies',
    },
  },
});

const ele = document.getElementById('root');
if (ele) {
  const root = createRoot(ele, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
